import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { paymentsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";


const usePayoutsCompleteMutation = ({
	paidYear,
	paidMonth,
	onSuccessHandler,
}: {
	paidYear: string;
	paidMonth: string;
	onSuccessHandler?: Function;
}) => {
	const dispatch = useDispatch();

	return useMutation(
		() => {
			dispatch(uiActions.showSpinnerOverlay());
			return paymentsService.completePayoutsReview({
				paidYear,
				paidMonth,
			});
		},
		{
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
			onSuccess() {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Successfully completed",
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default usePayoutsCompleteMutation;
